import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import EnhancedTable from '../users/tableComponent/EnhancedTable';
import 'react-toastify/dist/ReactToastify.css';
import {toast, ToastContainer} from 'react-toastify';


//import service
import UserService from "../../../services/UserService";
import Spinner from "reactjs-simple-spinner";
import {makeStyles} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));
const Users = (props) => {
    const [activateLoading, setActivateLoading] = useState(false);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'firstName',
            },
            {
                Header: 'Surname',
                accessor: 'lastName',
            },

            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({value}) => (
                    <span>
                       {value == '1' ? (
                           <span className="badge text-capitalize bg-success p-2">Active</span>
                       ) : (
                           <span className="badge text-capitalize bg-danger p-2">Inactive</span>
                       )}
                    </span>
                )
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({row, value}) => (
                    <span>
                        {row.original.status == '1' ? (
                            <Link className="btn btn-sm btn-danger " onClick={() => deactivate(value)}>
                                DeActivate &nbsp;<i className="fa fa-power-off"/>
                            </Link>
                        ) : (
                            <Link className="btn btn-sm btn-success " onClick={() => activate(value)}>
                                Activate &nbsp;<i className="fa fa-check-circle"/>
                            </Link>
                        )}

                        <Link className="btn btn-sm btn-primary " onClick={() => viewUser(row)}>
                            View &nbsp;<i className="fa fa-eye"/>
                        </Link>
                         <Link className="btn btn-sm btn-dark " onClick={() => handleOpen(row)}>
                            Reset Password &nbsp;<i className="fa fa-lock-open"/>
                        </Link>

                    </span>
                )
            },
        ],
        []
    )

    const [user, setUser] = useState({})
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = (row) => {
        setUser(row.original)
        setOpen(true);
    };

    const activate = (id) => {
        let u = []
        setActivateLoading(true);
        //call activate endpoint
        UserService.activate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' User Activated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                UserService.getAllUsers().then(response => {
                    console.log(response.data);
                    response.data.map((r, i) => {
                        if (r.firstName !== 'Super') {
                            u.push(r)
                        }
                    })
                    setData(u);
                    setActivateLoading(false)
                }).catch(err => {
                    console.log(err);
                    setActivateLoading(false)
                });
                setActivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setActivateLoading(false);
            })

    }

    const deactivate = (id) => {

        setDeactivateLoading(true)
        let u = []
        //call deactivate endpoint
        UserService.deactivate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' User Deactivated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                UserService.getAllUsers().then(response => {
                    console.log(response.data);
                    response.data.map((r, i) => {
                        if (r.firstName !== 'Super') {
                            u.push(r)
                        }
                    })
                    setData(u);
                    setDeactivateLoading(false)
                }).catch(err => {
                    console.log(err);
                    setDeactivateLoading(false)
                });
                setDeactivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setDeactivateLoading(false)
            })
    }

    const viewUser = (user) => {
        console.log("user: ", user.original)
        // set user to localStorage
        localStorage.setItem('viewUser', JSON.stringify(user.original));
        // push to viewUser page
        props.history.push('/view-user');
    }


    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)

// We need to keep the table from resetting the pageIndex when we
// Update data. So we can keep track of that flag with a ref.

// When our cell renderer calls updateMyData, we'll use
// the rowIndex, columnId and new value to update t

const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    // setSkipPageReset(true)
    setData(old =>
        old.map((row, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                }
            }
            return row
        })
    )
}
    const [loading, setLoading] = useState(false);
    const [resetLoading, setResetLoading] = useState(false);

    const [password, setPassword] = useState("********");

    const generatePassword = () => {
        // Create a random password
        const randomPassword =
            Math.random().toString(36).slice(2);

        // Set the generated password as state
        setPassword(randomPassword);

        // copy the password to the clipboard & fire toast message
        if (navigator.clipboard.writeText(randomPassword)) {
            toast('Password copied to your clipboard', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        handleClose()
        let users = []
        UserService.getAllUsers().then(response => {
            console.log(response.data);
            response.data.map((r, i) => {
                if (r.firstName !== 'Super') {
                 users.push(r)
             }
         })
            setData(users);
            setLoading(false)

        }).catch(err => {
            console.log(err);
            setData([])
            setLoading(false)
        });

    }, []);


    const handleResetPassword = (e) => {
        e.preventDefault();
        setResetLoading(true);


        let data = {
            'email': user.email,
            'password': password
        }

        console.log(data);

        UserService.resetPassword(data)
            .then(res => {
                console.log("response: ", res.response)
                if (res.status === 200) {
                    console.log(res);
                    toast.success('Password Reset Successful', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    setResetLoading(false);
                    handleClose()

                } else if (res.status === 400) {

                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setResetLoading(false);
                } else {
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setResetLoading(false);
                }

            }).catch(err => {
            console.log("error: ", err.response);
            setResetLoading(false);
            toast.warning('Operation Failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        })


    }


    return (
        <div>
            {/* Same as */}
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="container">
                    <form className="loader">
                        <div className="login-wrap p-5 mt-5">
                            <Spinner
                                size="large"
                                message="Please Wait..."
                                line-fg-color="#64c3c2"
                            />
                        </div>
                    </form>
                </div>
            )}
            {!loading && (
                <div
                    id="main-content"
                    className="main-panel ps-container ps-theme-default">
                    <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    {/*UPDATE MODAL*/}
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes.paper}>
                                <div>
                                    <Dialog
                                        open={open}
                                        onClose={handleClose}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <DialogTitle id="form-dialog-title">Reset User Password</DialogTitle>
                                        {resetLoading && (
                                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                                <Spinner
                                                    size="large"
                                                    message="Resetting Password,Please wait....."
                                                    line-fg-color="#64c3c2"
                                                />
                                            </div>
                                        )}
                                        {!resetLoading && (
                                            <>
                                                <DialogContent>
                                                    <DialogContentText></DialogContentText>
                                                    <TextField
                                                        margin="dense"
                                                        label="Token Verified"
                                                        type="text"
                                                        disabled={true}
                                                        fullWidth
                                                    />
                                                    <TextField
                                                        margin="dense"
                                                        value={user.email}
                                                        type="text"
                                                        disabled={true}
                                                        fullWidth
                                                    />
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <TextField
                                                                autoFocus
                                                                margin="dense"
                                                                type="text"
                                                                fullWidth
                                                                value={password}
                                                                disabled={true}
                                                                style={{backgroundColor: "#f6f4f4"}}
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <button onClick={generatePassword}
                                                                    className="btn btn-sm btn-dark">
                                                                Generate Password
                                                            </button>
                                                        </div>

                                                    </div>

                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleClose} color="primary">
                                                        Cancel
                                                    </Button>
                                                    <Button onClick={handleResetPassword}
                                                            className="btn btn-round btn-sm btn-primary">
                                                        Reset Password
                                                    </Button>
                                                </DialogActions>
                                            </>
                                        )}

                                    </Dialog>
                                </div>
                            </div>
                        </Fade>
                    </Modal>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                 &nbsp;|&nbsp;
                                <span className="upper-class">Users</span>
                            </ul>
                            {activateLoading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="medium"
                                        message="Activating User,Good things takes time Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>

                            )}
                            {deactivateLoading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="medium"
                                        message="Deactivating User,Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>

                            )}
                            {!activateLoading && !deactivateLoading && (
                                <div className="row mt">
                                    <div className="col-lg-12">
                                        <div className="content-panel bg-white">
                                            <div id="table">
                                                {/*Payments table*/}
                                                <CssBaseline/>
                                                <EnhancedTable
                                                    columns={columns}
                                                    data={data}
                                                    setData={setData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/*    Tabs Navigation*/}
                        </div>
                    </div>
                </div>

            )}

        </div>
    )
}

export default Users
